import Phaser from 'phaser';

export default class SauceSquirtPoints {
  /**
   * 
   * @param {Phaser.Textures.CanvasTexture} myCanvas 
   * @param {*} color 
   * @param {*} bottomzone 
   */
  constructor(myCanvas, color, bottomzone) {
    this.paintCanvas = myCanvas;

    this.color = color;
    this.bottomZone = bottomzone;
    this.pts = [];
    this.stroke = 1;
  }

  addPoint (x,y) {
    this.pts.push({ x, y, stroke: this.stroke });
    if (this.stroke < 13) {
      this.stroke += 0.175;
    }
  }

  render () {
    const g = this.paintCanvas;
    const ctx = g.context;
    const len = this.pts.length;
    for (let i = 0; i < len - 1; i++) {
      ctx.strokeStyle = this.color;
      ctx.lineWidth = this.pts[i].stroke;
      ctx.lineCap = 'round';
      ctx.beginPath();

      // place the cursor from the point the line should be started 
      ctx.moveTo(this.pts[i].x, this.pts[i].y);

      // draw a line from current cursor position to the provided x,y coordinate
      ctx.lineTo(this.pts[i + 1].x, this.pts[i + 1].y);

      // add stroke to the line 
      ctx.stroke();
    }

    return this.paintCanvas;
  }

  update (dt) {
    const len = this.pts.length - 1;
    for (let i = len; i >= 0; i--) {
      this.pts[i].y += 240 * dt;
      if (this.pts[i].y > this.bottomZone) {
        this.pts.splice(i,1);
      }
    }

    return this.pts.length === 0;
  }
}